/* eslint-disable */
import React, { useState, useEffect } from 'react';
import { teamAPI, workspaceAPI } from '../services/api';
import { useAuth } from '../contexts/AuthContext';

// ─── Palette v7 ──────────────────────────────────────────────────────────
const C = {
  bg:        '#faf8f3',
  card:      '#ffffff',
  border:    'rgba(0,0,0,0.08)',
  borderLt:  'rgba(0,0,0,0.04)',
  borderDk:  'rgba(0,0,0,0.12)',
  text:      '#1d1d1f',
  text2:     '#424245',
  text3:     '#8b8576',
  gold:      'var(--brand-primary, #c78c2a)',
  goldBg:    'var(--brand-primary-bg, rgba(199,140,42,0.12))',
  goldDk:    'var(--brand-primary, #6b4f00)',
  green:     '#248a3d',
  greenBg:   'rgba(52,199,89,0.12)',
  amber:     '#a25500',
  amberBg:   'rgba(255,149,0,0.14)',
  red:       '#c41e3a',
  gray:      '#8b8576',
  grayBg:    'rgba(0,0,0,0.05)',
};
const FONT_TITLE = 'var(--font-title)';
const FONT_BODY  = 'var(--font-body)';

const fmtNum = (n) => Number(n || 0).toLocaleString('fr-FR');

function chargeColor(pct) {
  if (pct >= 90) return C.red;
  if (pct >= 70) return C.amber;
  return C.green;
}

// ─── Offres formaliste ─────────────────────────────────────────
const OFFRES = [
  {
    id: 'flex',
    label: 'Flex',
    tagline: 'Paiement à la consommation',
    prix: '50 €',
    prixSuffix: 'HT / dossier',
    points: [
      'Sans engagement ni abonnement',
      'Facturé en fin de mois selon les dossiers traités',
      'Idéal : petit volume ou activité irrégulière',
    ],
    cta: 'Commencer en Flex',
    highlight: false,
    dashed: false,
  },
  {
    id: 'entreprise',
    label: 'Entreprise',
    tagline: 'Formaliste dédié',
    prix: '1 200 €',
    prixSuffix: 'HT / mois par formaliste',
    points: [
      "Jusqu'à 70 dossiers / mois inclus",
      'Capacité réservée · formaliste diplômé en droit français',
      'Ajoutez autant de formalistes que nécessaire',
    ],
    cta: 'Choisir Entreprise',
    highlight: true,
    dashed: false,
    badge: 'Recommandé',
  },
  {
    id: 'devis',
    label: 'Sur devis',
    tagline: 'Gros volume',
    prix: '> 70',
    prixSuffix: 'formalités / mois',
    points: [
      'Tarif dégressif · multi-formalistes',
      'Accompagnement dédié',
      'Idéal : forts volumes récurrents',
    ],
    cta: 'Demander un devis',
    highlight: false,
    dashed: true,
  },
];

// ═══════════════════════════════════════════════════════════════
// FORMALISTE CARD
// ═══════════════════════════════════════════════════════════════

function FormalisteCard({ f, isAdmin, onToggleLexback, toggling }) {
  const barColor = chargeColor(f.charge_pct);
  const gradientFrom = f.is_lexback_team ? C.gold : '#2563eb';

  return (
    <div style={{
      background: C.card,
      border: `1px solid ${C.border}`,
      borderRadius: '12px',
      padding: '1.25rem 1.4rem',
      boxShadow: '0 1px 2px rgba(20,18,14,0.03)',
      display: 'flex',
      gap: '14px',
      alignItems: 'flex-start',
    }}>
      <div style={{
        width: '48px', height: '48px',
        borderRadius: '10px',
        background: `linear-gradient(135deg, ${gradientFrom}, ${C.text})`,
        color: '#fff',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontFamily: FONT_TITLE,
        fontSize: '16px',
        fontWeight: 600,
        flexShrink: 0,
      }}>{f.initiales}</div>

      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '4px' }}>
          <div style={{ fontSize: '15px', fontWeight: 500, color: C.text }}>{f.prenom} {f.nom}</div>
          <span style={{
            fontSize: '11px',
            fontWeight: 500,
            padding: '3px 10px',
            borderRadius: '20px',
            background: f.is_active ? C.greenBg : C.borderLt,
            color: f.is_active ? C.green : C.text3,
          }}>{f.is_active ? 'Disponible' : 'Hors ligne'}</span>
        </div>

        <div style={{ fontSize: '12px', color: C.text3, marginBottom: '10px', lineHeight: 1.5 }}>
          {f.role}
          {f.anciennete_mois ? ` · ${f.anciennete_mois} mois` : ''}
          {f.specialites?.length > 0 ? ` · ${f.specialites.join(', ')}` : ''}
        </div>

        <div style={{ display: 'flex', gap: '18px', fontSize: '12px', color: C.text2, marginBottom: '12px' }}>
          {f.satisfaction != null && (<span><strong style={{ color: C.text, fontWeight: 600 }}>{f.satisfaction}/5</strong> satisfaction</span>)}
          {f.delai_moyen_h != null && (<span><strong style={{ color: C.text, fontWeight: 600 }}>{(f.delai_moyen_h / 24).toFixed(1)}j</strong> délai moyen</span>)}
          {f.dossiers_mois != null && (<span><strong style={{ color: C.text, fontWeight: 600 }}>{f.dossiers_mois}</strong> dossiers ce mois</span>)}
        </div>

        <div>
          <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '11px', marginBottom: '5px' }}>
            <span style={{ color: C.text3 }}>Capacité de charge</span>
            <span style={{ fontWeight: 500, color: barColor }}>{f.dossiers_actifs} / {f.capacite_max} dossiers</span>
          </div>
          <div style={{ height: '6px', background: C.borderLt, borderRadius: '3px', overflow: 'hidden' }}>
            <div style={{
              width: `${Math.min(100, f.charge_pct)}%`,
              height: '100%',
              background: barColor,
              borderRadius: '3px',
              transition: 'width 0.4s',
            }} />
          </div>
        </div>

        {/* Action admin : toggle équipe Lexback */}
        {isAdmin && onToggleLexback && (
          <div style={{ marginTop: '12px', paddingTop: '10px', borderTop: `1px solid ${C.borderLt}` }}>
            <button
              onClick={() => onToggleLexback(f)}
              disabled={toggling}
              style={{
                background: 'transparent',
                border: `1px solid ${C.border}`,
                color: C.text2,
                padding: '5px 11px',
                borderRadius: '6px',
                fontSize: '11.5px',
                fontWeight: 500,
                cursor: toggling ? 'not-allowed' : 'pointer',
                opacity: toggling ? 0.6 : 1,
                fontFamily: FONT_BODY,
              }}
            >
              {toggling
                ? '…'
                : f.is_lexback_team
                  ? '↩ Déplacer vers équipe interne'
                  : '→ Marquer comme équipe Lexback'
              }
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

function AddCard({ label, sub, onClick }) {
  return (
    <div onClick={onClick} style={{
      background: C.bg,
      border: `1.5px dashed ${C.borderDk}`,
      borderRadius: '12px',
      padding: '24px',
      cursor: onClick ? 'pointer' : 'default',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      textAlign: 'center',
      minHeight: '180px',
    }}>
      <div style={{
        width: '44px', height: '44px',
        borderRadius: '10px',
        background: C.card,
        border: `1px solid ${C.borderDk}`,
        color: C.text3,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginBottom: '10px',
        fontSize: '22px',
        fontWeight: 300,
      }}>+</div>
      <div style={{ fontSize: '13.5px', fontWeight: 500, color: C.text, marginBottom: '3px' }}>{label}</div>
      <div style={{ fontSize: '11.5px', color: C.text3, lineHeight: 1.5 }}>{sub}</div>
    </div>
  );
}

// ═══════════════════════════════════════════════════════════════
// AGENT CARD
// ═══════════════════════════════════════════════════════════════

const AGENT_ICONS = {
  suivi:    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/></svg>,
  jal:      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M4 22h16a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H8a2 2 0 0 0-2 2v16a2 2 0 0 1-2 2zm0 0a2 2 0 0 1-2-2v-9c0-1.1.9-2 2-2h2"/><path d="M18 14h-8"/><path d="M15 18h-5"/><path d="M10 6h8v4h-8V6Z"/></svg>,
  saisie:   <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>,
  kyb:      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><path d="m9 12 2 2 4-4"/></svg>,
  mail:     <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>,
  phone:    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/></svg>,
};

// Statuts visuels
const STATUS_LABELS = {
  active:    { label: 'Actif',          bg: C.greenBg, color: C.green,   dot: C.green },
  inactive:  { label: 'Désactivé',      bg: C.grayBg,  color: C.text3,   dot: C.text3 },
  optional:  { label: 'Sur demande',    bg: C.goldBg,  color: C.goldDk,  dot: C.gold  },
  coming:    { label: 'Bientôt',        bg: C.grayBg,  color: C.text3,   dot: '#bbb'  },
  blocked:   { label: 'À configurer',   bg: C.amberBg, color: C.amber,   dot: C.amber },
};

function AgentCard({ agent, onToggle, onRequest }) {
  const status = STATUS_LABELS[agent.status] || STATUS_LABELS.inactive;
  const isActionable = agent.status !== 'coming' && !agent.locked;

  return (
    <div style={{
      background: C.card,
      border: `1px solid ${C.border}`,
      borderRadius: '12px',
      padding: '1.25rem 1.4rem',
      boxShadow: '0 1px 2px rgba(20,18,14,0.03)',
      display: 'flex',
      gap: '14px',
      alignItems: 'flex-start',
      opacity: agent.status === 'coming' ? 0.65 : 1,
    }}>
      {/* Icône */}
      <div style={{
        width: '48px', height: '48px',
        borderRadius: '10px',
        background: agent.status === 'active'
          ? `linear-gradient(135deg, ${C.gold}, ${C.text})`
          : agent.status === 'coming'
          ? '#e5e7eb'
          : `linear-gradient(135deg, ${C.text3}, ${C.text})`,
        color: '#fff',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
      }}>{agent.icon}</div>

      <div style={{ flex: 1, minWidth: 0 }}>
        {/* Header */}
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '4px', gap: '8px' }}>
          <div style={{ fontSize: '14.5px', fontWeight: 500, color: C.text }}>{agent.name}</div>
          <span style={{
            fontSize: '11px',
            fontWeight: 500,
            padding: '3px 10px',
            borderRadius: '20px',
            background: status.bg,
            color: status.color,
            display: 'inline-flex',
            alignItems: 'center',
            gap: '5px',
            whiteSpace: 'nowrap',
          }}>
            <span style={{ width: '6px', height: '6px', borderRadius: '50%', background: status.dot }} />
            {status.label}
          </span>
        </div>

        {/* Description */}
        <div style={{ fontSize: '12px', color: C.text2, marginBottom: '10px', lineHeight: 1.55 }}>
          {agent.description}
        </div>

        {/* Tag inclus / payant */}
        {agent.priceLabel && (
          <div style={{
            display: 'inline-block',
            fontSize: '10.5px',
            fontWeight: 600,
            padding: '2px 8px',
            borderRadius: '4px',
            background: agent.included ? C.greenBg : C.goldBg,
            color: agent.included ? C.green : C.goldDk,
            marginBottom: '10px',
            textTransform: 'uppercase',
            letterSpacing: '0.04em',
          }}>
            {agent.priceLabel}
          </div>
        )}

        {/* Stats si dispo */}
        {agent.actionsCount != null && (
          <div style={{ fontSize: '11.5px', color: C.text3, marginBottom: '10px' }}>
            <strong style={{ color: C.text, fontWeight: 600 }}>{fmtNum(agent.actionsCount)}</strong> actions ce mois
          </div>
        )}

        {/* Action button */}
        {isActionable && (
          <div style={{ display: 'flex', gap: '8px' }}>
            {agent.status === 'optional' ? (
              <button
                onClick={onRequest}
                style={{
                  background: C.text,
                  color: '#fff',
                  border: 'none',
                  padding: '6px 12px',
                  borderRadius: '6px',
                  fontSize: '12px',
                  fontWeight: 500,
                  cursor: 'pointer',
                  fontFamily: FONT_BODY,
                }}
              >
                Demander l'activation →
              </button>
            ) : agent.status === 'blocked' ? (
              <button
                onClick={onRequest}
                style={{
                  background: C.amberBg,
                  color: C.amber,
                  border: `1px solid ${C.amberBg}`,
                  padding: '6px 12px',
                  borderRadius: '6px',
                  fontSize: '12px',
                  fontWeight: 500,
                  cursor: 'pointer',
                  fontFamily: FONT_BODY,
                }}
              >
                Configurer →
              </button>
            ) : (
              <button
                onClick={onToggle}
                style={{
                  background: C.card,
                  color: C.text2,
                  border: `1px solid ${C.border}`,
                  padding: '6px 12px',
                  borderRadius: '6px',
                  fontSize: '12px',
                  fontWeight: 500,
                  cursor: 'pointer',
                  fontFamily: FONT_BODY,
                }}
              >
                {agent.status === 'active' ? 'Désactiver' : 'Activer'}
              </button>
            )}
          </div>
        )}
      </div>
    </div>
  );
}

// ═══════════════════════════════════════════════════════════════
// AGENTS LIST (mock — Option A)
// ═══════════════════════════════════════════════════════════════

function buildAgentsList({ hasEmailRelance }) {
  return [
    {
      key: 'suivi_formalite',
      icon: AGENT_ICONS.suivi,
      name: 'Agent Suivi formalité',
      description: "Scrape automatiquement le portail INPI toutes les heures pour mettre à jour le statut de vos dossiers. Vous n'avez plus besoin de vérifier manuellement.",
      status: 'active',
      included: true,
      priceLabel: 'Inclus',
      actionsCount: null,
    },
    {
      key: 'publication_jal',
      icon: AGENT_ICONS.jal,
      name: 'Agent Publication JAL',
      description: "Publie automatiquement vos annonces légales chez les journaux d'annonces partenaires. Récupère l'attestation et la classe dans le dossier.",
      status: 'active',
      included: true,
      priceLabel: 'Inclus',
      actionsCount: null,
    },
    {
      key: 'saisie_inpi',
      icon: AGENT_ICONS.saisie,
      name: 'Agent Saisie INPI',
      description: "Pour les clients sans formaliste interne : remplit automatiquement les formulaires INPI Guichet Unique à partir des données du dossier.",
      status: 'optional',
      included: false,
      priceLabel: 'Add-on',
    },
    {
      key: 'kyb_klear',
      icon: AGENT_ICONS.kyb,
      name: 'Klear — Vérification KYB documentaire',
      description: "Vérifie la cohérence des documents fournis (Kbis, statuts, RIB, CNI dirigeant) et détecte les altérations via Claude Vision + croisement Pappers/INSEE.",
      status: 'optional',
      included: false,
      priceLabel: 'Add-on',
    },
    {
      key: 'relance_email',
      icon: AGENT_ICONS.mail,
      name: 'Relances clients par email',
      description: "Relance automatiquement vos clients finaux pour récupérer les pièces manquantes. Nécessite Zendesk ou une boîte mail connectée.",
      status: hasEmailRelance ? 'active' : 'blocked',
      included: true,
      priceLabel: 'Inclus',
    },
    {
      key: 'relance_phone',
      icon: AGENT_ICONS.phone,
      name: 'Relances clients par téléphone IA',
      description: "Voix IA française qui appelle vos clients finaux pour leur rappeler les pièces manquantes. Disponible prochainement.",
      status: 'coming',
      included: false,
      priceLabel: null,
    },
  ];
}

// ═══════════════════════════════════════════════════════════════
// PAGE PRINCIPALE
// ═══════════════════════════════════════════════════════════════

export default function Formalistes() {
  const { user } = useAuth();
  const isAdmin = user?.role === 'admin' || user?.role === 'superviseur';

  const [formalistes, setFormalistes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [tab, setTab] = useState('internal'); // 'internal' | 'lexback' | 'agents' | 'runbook'
  const [togglingId, setTogglingId] = useState(null);

  // Workspace : pour connaître le service_model (plateforme_only / plateforme_lexback)
  const [workspace, setWorkspace] = useState(null);

  // Connecteurs : sait si Zendesk actif pour les relances email
  const [hasEmailRelance, setHasEmailRelance] = useState(false);

  // Runbook : instructions de travail pour l'équipe
  const [runbook, setRunbook] = useState(null);
  const [savingRunbook, setSavingRunbook] = useState(false);
  const [runbookToast, setRunbookToast] = useState(null);

  useEffect(() => {
    loadData();
    loadConnectors();
    loadRunbook();
    loadWorkspace();
  }, []);

  const loadWorkspace = async () => {
    try {
      const r = await workspaceAPI.get();
      setWorkspace(r.data || null);
    } catch {
      setWorkspace(null);
    }
  };

  const loadRunbook = async () => {
    try {
      const r = await workspaceAPI.getRunbook();
      setRunbook(r.data || {});
    } catch {
      setRunbook({});
    }
  };

  const handleSaveRunbook = async () => {
    if (!runbook) return;
    setSavingRunbook(true);
    try {
      await workspaceAPI.updateRunbook(runbook);
      setRunbookToast('Runbook sauvegardé');
      setTimeout(() => setRunbookToast(null), 2500);
    } catch {
      setRunbookToast('Erreur lors de la sauvegarde');
      setTimeout(() => setRunbookToast(null), 3000);
    } finally {
      setSavingRunbook(false);
    }
  };

  const loadData = async () => {
    setLoading(true);
    try {
      const res = await teamAPI.formalistes();
      setFormalistes(res.data || []);
    } catch {
      setFormalistes([]);
    } finally {
      setLoading(false);
    }
  };

  const loadConnectors = async () => {
    try {
      const res = await workspaceAPI.connectors();
      const list = Array.isArray(res.data) ? res.data : [];
      const hasZendesk = list.some(c => c.type === 'zendesk' && c.is_active);
      setHasEmailRelance(hasZendesk);
    } catch {
      setHasEmailRelance(false);
    }
  };

  // Filtrage
  const internal = formalistes.filter(f => !f.is_lexback_team);
  const lexback  = formalistes.filter(f => f.is_lexback_team);
  const visible  = tab === 'internal' ? internal : tab === 'lexback' ? lexback : [];

  // Agents
  const agents = buildAgentsList({ hasEmailRelance });

  // Stats charges
  const sumActifs   = (list) => list.reduce((acc, f) => acc + (f.dossiers_actifs || 0), 0);
  const sumCapacity = (list) => list.reduce((acc, f) => acc + (f.capacite_max || 0), 0);
  const internalActifs   = sumActifs(internal);
  const internalCapacity = sumCapacity(internal);
  const internalPct      = internalCapacity > 0 ? Math.round((internalActifs / internalCapacity) * 100) : 0;
  const lexbackActifs    = sumActifs(lexback);
  const lexbackCapacity  = sumCapacity(lexback);
  const lexbackPct       = lexbackCapacity > 0 ? Math.round((lexbackActifs / lexbackCapacity) * 100) : 0;

  const workspaceName = user?.workspace?.name || 'Mon espace';
  // service_model du workspace détermine la formule active
  // fallback : si pas chargé encore, on déduit par présence de formalistes Lexback
  const hasLexbackTeam = workspace
    ? workspace.service_model === 'plateforme_lexback'
    : lexback.length > 0;

  // Stats agents
  const activeAgents = agents.filter(a => a.status === 'active').length;

  // Handlers agents
  const handleAgentRequest = (agent) => {
    const subject = encodeURIComponent(`Demande activation : ${agent.name}`);
    const body = encodeURIComponent(`Bonjour,\n\nJe souhaite activer l'agent "${agent.name}" sur mon workspace ${workspaceName}.\n\nCordialement,`);
    window.location.href = `mailto:contact@swap-business.com?subject=${subject}&body=${body}`;
  };

  const handleAgentToggle = (agent) => {
    // Mock toggle pour ce soir — pas de persistance backend
    // Un vrai toggle sera implémenté en Option B (router + endpoint)
    alert(`Toggle "${agent.name}" → bientôt disponible.`);
  };

  // Demande d'offre formaliste (Flex / Entreprise / Sur devis)
  const handleOffreRequest = (offre) => {
    const subject = encodeURIComponent(`Demande offre : ${offre.label}`);
    const body = encodeURIComponent(
      `Bonjour,\n\nJe souhaite en savoir plus sur l'offre ${offre.label} pour mon espace ${workspaceName}.\n\nCordialement,`
    );
    window.location.href = `mailto:contact@swap-business.com?subject=${subject}&body=${body}`;
  };

  // Toggle is_lexback_team d'un formaliste (admin/superviseur seulement)
  const handleToggleLexback = async (f) => {
    if (togglingId) return;
    setTogglingId(f.id);
    try {
      await teamAPI.setLexbackTeam(f.id, !f.is_lexback_team);
      // Mise à jour optimiste en local
      setFormalistes(list => list.map(x =>
        x.id === f.id ? { ...x, is_lexback_team: !x.is_lexback_team } : x
      ));
    } catch (e) {
      alert("Impossible de modifier l'équipe du formaliste.");
    } finally {
      setTogglingId(null);
    }
  };

  if (loading) {
    return (
      <div style={{ padding: '3rem', textAlign: 'center', color: C.text3, fontSize: '13px', fontFamily: FONT_BODY }}>
        Chargement…
      </div>
    );
  }

  return (
    <div style={{ fontFamily: FONT_BODY, color: C.text }}>

      {/* ─── Page header ─── */}
      <div style={{ marginBottom: '24px' }}>
        <h1 style={{
          fontFamily: FONT_TITLE,
          fontSize: '2.6rem',
          fontWeight: 700,
          letterSpacing: '-0.035em',
          lineHeight: 1.15,
          marginBottom: '6px',
          color: C.text,
        }}>
          Vos <span style={{ color: C.gold, fontWeight: 600 }}>équipes</span>
        </h1>
        <p style={{ fontSize: '0.95rem', color: C.text2, maxWidth: '640px', lineHeight: 1.55 }}>
          Vos formalistes internes, l'équipe Lexback en option, et vos agents IA. Tous les collaborateurs humains et virtuels qui traitent vos dossiers.
        </p>
      </div>

      {/* ─── Bloc offres formaliste (caché sur agents et runbook) ─── */}
      {tab !== 'agents' && tab !== 'runbook' && (
        <div style={{ marginBottom: '24px' }}>
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(3, 1fr)',
            gap: '10px',
            alignItems: 'stretch',
          }}>
            {OFFRES.map(o => (
              <div key={o.id} style={{
                position: 'relative',
                background: o.highlight ? C.goldBg : C.card,
                border: o.highlight
                  ? `1.5px solid ${C.gold}`
                  : o.dashed
                    ? `1px dashed ${C.borderDk}`
                    : `1px solid ${C.border}`,
                borderRadius: '14px',
                padding: '20px',
                display: 'flex',
                flexDirection: 'column',
              }}>
                {o.badge && (
                  <span style={{
                    position: 'absolute',
                    top: '14px',
                    right: '14px',
                    fontSize: '10px',
                    fontWeight: 600,
                    textTransform: 'uppercase',
                    letterSpacing: '0.04em',
                    background: C.gold,
                    color: '#fff',
                    padding: '2px 8px',
                    borderRadius: '99px',
                  }}>{o.badge}</span>
                )}

                <div style={{
                  fontSize: '11px',
                  fontWeight: 600,
                  textTransform: 'uppercase',
                  letterSpacing: '0.06em',
                  color: o.highlight ? C.goldDk : C.text3,
                  marginBottom: '12px',
                }}>
                  {o.label}
                </div>

                <div style={{ display: 'flex', alignItems: 'baseline', gap: '6px', marginBottom: '4px' }}>
                  <span style={{ fontFamily: FONT_TITLE, fontSize: '28px', fontWeight: 700, lineHeight: 1, color: C.text }}>
                    {o.prix}
                  </span>
                  <span style={{ fontSize: '12px', color: C.text2 }}>{o.prixSuffix}</span>
                </div>

                <div style={{ fontSize: '13px', color: C.text2, marginBottom: '14px' }}>{o.tagline}</div>

                <div style={{ display: 'flex', flexDirection: 'column', gap: '7px', marginBottom: '18px', flex: 1 }}>
                  {o.points.map((p, i) => (
                    <div key={i} style={{ display: 'flex', gap: '8px', fontSize: '12.5px', color: C.text2, lineHeight: 1.45 }}>
                      <span style={{ color: C.gold, flexShrink: 0, fontWeight: 600 }}>›</span>
                      <span>{p}</span>
                    </div>
                  ))}
                </div>

                <button onClick={() => handleOffreRequest(o)} style={{
                  width: '100%',
                  background: o.highlight ? C.gold : 'transparent',
                  color: o.highlight ? '#fff' : C.text,
                  border: o.highlight ? 'none' : `1px solid ${C.borderDk}`,
                  borderRadius: '8px',
                  padding: '9px 0',
                  fontSize: '12.5px',
                  fontWeight: 600,
                  cursor: 'pointer',
                  fontFamily: FONT_BODY,
                }}>{o.cta}</button>
              </div>
            ))}
          </div>

          <div style={{ marginTop: '12px', fontSize: '11.5px', color: C.text3, lineHeight: 1.6 }}>
            Dans toutes les offres, les débours (frais de greffe, JAL) sont réglés directement via votre wallet INPI.
            {' · '}
            Point de bascule : au-delà de ~24 dossiers/mois, l'offre Entreprise devient plus avantageuse que le Flex.
          </div>
        </div>
      )}

      {/* ─── Tabs ─── */}
      <div style={{
        display: 'inline-flex',
        gap: '4px',
        background: C.borderLt,
        border: `1px solid ${C.border}`,
        borderRadius: '10px',
        padding: '4px',
        marginBottom: '20px',
      }}>
        {[
          { id: 'internal', label: `Mon équipe interne (${internal.length})` },
          { id: 'lexback',  label: `Équipe Lexback dédiée (${lexback.length})` },
          { id: 'agents',   label: `Agents IA (${activeAgents})` },
          { id: 'runbook',  label: 'Runbook' },
        ].map(t => (
          <button
            key={t.id}
            onClick={() => setTab(t.id)}
            style={{
              background: tab === t.id ? C.card : 'transparent',
              border: 'none',
              padding: '9px 16px',
              fontSize: '13px',
              fontFamily: FONT_BODY,
              cursor: 'pointer',
              borderRadius: '7px',
              fontWeight: tab === t.id ? 500 : 400,
              color: tab === t.id ? C.text : C.text2,
              boxShadow: tab === t.id ? '0 1px 2px rgba(0,0,0,0.06)' : 'none',
            }}
          >{t.label}</button>
        ))}
      </div>

      {/* ════════════════════════════════════════════════════════ */}
      {/* ONGLET HUMAINS : interne / lexback                       */}
      {/* ════════════════════════════════════════════════════════ */}
      {tab !== 'agents' && tab !== 'runbook' && (
        <>
          {/* Hero panel équipe */}
          <div style={{
            background: C.card,
            border: `1px solid ${C.border}`,
            borderRadius: '12px',
            padding: '1.5rem',
            marginBottom: '20px',
            display: 'flex',
            gap: '24px',
            alignItems: 'center',
            boxShadow: '0 1px 2px rgba(20,18,14,0.03)',
          }}>
            <div style={{ flex: 1 }}>
              <h2 style={{ fontFamily: FONT_TITLE, fontSize: '20px', fontWeight: 600, letterSpacing: '-0.02em', color: C.text, marginBottom: '6px' }}>
                {tab === 'internal'
                  ? `Vos ${internal.length} formaliste${internal.length > 1 ? 's' : ''} interne${internal.length > 1 ? 's' : ''}`
                  : `${lexback.length} formaliste${lexback.length > 1 ? 's' : ''} Lexback dédié${lexback.length > 1 ? 's' : ''} à ${workspaceName}`
                }
              </h2>
              <p style={{ fontSize: '13px', color: C.text2, lineHeight: 1.55, marginBottom: '14px' }}>
                {tab === 'internal'
                  ? <>Vos employés qui traitent les dossiers depuis Lexback. Ils utilisent <strong style={{ color: C.text, fontWeight: 600 }}>toute l'infrastructure</strong> : robots INPI, IA Klear, intégrations Aircall/Zendesk.</>
                  : <>Vos formalistes externes <strong style={{ color: C.text, fontWeight: 600 }}>diplômés en droit français</strong>, basés à Rabat. Ils traitent les dossiers que votre équipe interne ne peut pas absorber.</>
                }
              </p>
              {isAdmin && (
                <div style={{ display: 'flex', gap: '8px' }}>
                  <button style={{ background: C.text, color: '#fff', border: 'none', padding: '8px 14px', borderRadius: '7px', fontSize: '12.5px', fontWeight: 500, cursor: 'pointer', fontFamily: FONT_BODY }}>
                    + {tab === 'internal' ? 'Inviter un formaliste' : 'Ajouter un formaliste Lexback'}
                  </button>
                  <button style={{ background: C.card, color: C.text2, border: `1px solid ${C.border}`, padding: '8px 14px', borderRadius: '7px', fontSize: '12.5px', fontWeight: 400, cursor: 'pointer', fontFamily: FONT_BODY }}>
                    Gérer les rôles
                  </button>
                </div>
              )}
            </div>

            <div style={{
              background: C.bg,
              borderRadius: '10px',
              padding: '16px 20px',
              minWidth: '180px',
              textAlign: 'center',
            }}>
              <div style={{ fontSize: '11px', textTransform: 'uppercase', letterSpacing: '0.06em', color: C.text3, fontWeight: 600, marginBottom: '6px' }}>
                Charge équipe
              </div>
              <div style={{
                fontFamily: FONT_TITLE,
                fontSize: '2.2rem',
                fontWeight: 400,
                color: chargeColor(tab === 'internal' ? internalPct : lexbackPct),
                lineHeight: 1,
                letterSpacing: '-0.01em',
              }}>
                {tab === 'internal' ? internalPct : lexbackPct}%
              </div>
              <div style={{ fontSize: '11px', color: C.text3, marginTop: '6px' }}>
                {tab === 'internal'
                  ? `${internalActifs} / ${internalCapacity} dossiers`
                  : `${lexbackActifs} / ${lexbackCapacity} dossiers`
                }
              </div>
            </div>
          </div>

          {/* Liste formalistes */}
          {visible.length === 0 ? (
            <div style={{
              background: C.card,
              border: `1px solid ${C.border}`,
              borderRadius: '12px',
              padding: '3rem',
              textAlign: 'center',
            }}>
              <div style={{ fontFamily: FONT_TITLE, fontSize: '18px', fontWeight: 600, letterSpacing: '-0.02em', color: C.text, marginBottom: '6px' }}>
                {tab === 'internal' ? 'Aucun formaliste interne' : 'Aucun formaliste Lexback dédié'}
              </div>
              <div style={{ fontSize: '12.5px', color: C.text2, lineHeight: 1.6, marginBottom: '16px', maxWidth: '420px', margin: '0 auto 16px' }}>
                {tab === 'internal'
                  ? 'Invitez vos employés en charge des formalités pour qu\'ils accèdent à toute l\'infrastructure Lexback.'
                  : 'Ajoutez des formalistes Lexback pour absorber vos volumes au-delà de la capacité de votre équipe interne.'
                }
              </div>
            </div>
          ) : (
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '14px', marginBottom: '20px' }}>
              {visible.map(f => (
                <FormalisteCard
                  key={f.id}
                  f={f}
                  isAdmin={isAdmin}
                  toggling={togglingId === f.id}
                  onToggleLexback={handleToggleLexback}
                />
              ))}
              {isAdmin && (
                <AddCard
                  label={tab === 'internal' ? 'Inviter un formaliste' : 'Ajouter un formaliste Lexback'}
                  sub={tab === 'internal' ? '99 €/siège/mois après le 5e' : '2 800 €/mois par formaliste'}
                />
              )}
            </div>
          )}
        </>
      )}

      {/* ════════════════════════════════════════════════════════ */}
      {/* ONGLET AGENTS IA                                          */}
      {/* ════════════════════════════════════════════════════════ */}
      {tab === 'agents' && (
        <>
          {/* Hero agents */}
          <div style={{
            background: C.card,
            border: `1px solid ${C.border}`,
            borderRadius: '12px',
            padding: '1.5rem',
            marginBottom: '20px',
            display: 'flex',
            gap: '24px',
            alignItems: 'center',
            boxShadow: '0 1px 2px rgba(20,18,14,0.03)',
          }}>
            <div style={{ flex: 1 }}>
              <h2 style={{ fontFamily: FONT_TITLE, fontSize: '20px', fontWeight: 600, letterSpacing: '-0.02em', color: C.text, marginBottom: '6px' }}>
                <span style={{ color: C.gold, fontWeight: 600 }}>{activeAgents}</span> agent{activeAgents > 1 ? 's' : ''} IA actif{activeAgents > 1 ? 's' : ''} sur {agents.filter(a => a.status !== 'coming').length}
              </h2>
              <p style={{ fontSize: '13px', color: C.text2, lineHeight: 1.55 }}>
                Vos collaborateurs virtuels qui automatisent les tâches répétitives : suivi des dépôts INPI, publication d'annonces, relances clients, vérification documentaire. Disponibles 24/7.
              </p>
            </div>
            <div style={{
              background: C.bg,
              borderRadius: '10px',
              padding: '16px 20px',
              minWidth: '180px',
              textAlign: 'center',
            }}>
              <div style={{ fontSize: '11px', textTransform: 'uppercase', letterSpacing: '0.06em', color: C.text3, fontWeight: 600, marginBottom: '6px' }}>
                Disponibilité
              </div>
              <div style={{ fontFamily: FONT_TITLE, fontSize: '2.4rem', fontWeight: 700, letterSpacing: '-0.035em', color: C.green, lineHeight: 1, letterSpacing: '-0.01em' }}>
                24/7
              </div>
              <div style={{ fontSize: '11px', color: C.text3, marginTop: '6px' }}>
                Sans congés
              </div>
            </div>
          </div>

          {/* Liste agents */}
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '14px' }}>
            {agents.map(agent => (
              <AgentCard
                key={agent.key}
                agent={agent}
                onToggle={() => handleAgentToggle(agent)}
                onRequest={() => handleAgentRequest(agent)}
              />
            ))}
          </div>

          {/* Note bas de page */}
          <div style={{ marginTop: '20px', fontSize: '12px', color: C.text3, textAlign: 'center', lineHeight: 1.6 }}>
            Tous les agents respectent le RGPD et tracent leurs actions dans le journal d'audit du dossier.
          </div>
        </>
      )}

      {/* ════════════════════════════════════════════════════════ */}
      {/* ONGLET RUNBOOK                                            */}
      {/* ════════════════════════════════════════════════════════ */}
      {tab === 'runbook' && runbook && (
        <div style={{
          background: C.card,
          border: `1px solid ${C.border}`,
          borderRadius: '12px',
          padding: '1.5rem',
          boxShadow: '0 1px 2px rgba(20,18,14,0.03)',
        }}>
          <div style={{ marginBottom: '6px' }}>
            <div style={{ fontSize: '15px', fontWeight: 600, color: C.text, letterSpacing: '-0.01em' }}>
              Instructions de travail
            </div>
            <div style={{ fontSize: '12.5px', color: C.text2, marginTop: '4px', lineHeight: 1.55 }}>
              Comment vos formalistes et agents IA doivent traiter vos dossiers : ton, SLA, gestion des appels, langue.
            </div>
          </div>

          <div style={{
            display: 'grid',
            gridTemplateColumns: '1fr 1fr',
            gap: '14px',
            marginTop: '20px',
            marginBottom: '16px',
          }}>
            {[
              { key: 'appels_mode', label: 'Gestion des appels', opts: [['formulaire','Formulaire de contact'],['transfert','Transfert direct'],['rappel','Rappel automatique'],['jamais','Jamais d\'appel']] },
              { key: 'relance_greffe_freq', label: 'Relance greffes', opts: [['quotidien','Quotidienne'],['j2','Tous les 2 jours'],['hebdo','Hebdomadaire']] },
              { key: 'ton_communication', label: 'Ton de communication', opts: [['formel','Formel'],['informel','Informel']] },
              { key: 'langue', label: 'Langue', opts: [['fr','Français'],['en','Anglais']] },
            ].map(f => (
              <div key={f.key}>
                <div style={{
                  fontSize: '11px',
                  color: C.text3,
                  textTransform: 'uppercase',
                  letterSpacing: '0.06em',
                  fontWeight: 600,
                  marginBottom: '6px',
                }}>{f.label}</div>
                <select
                  value={runbook[f.key] || f.opts[0][0]}
                  onChange={e => setRunbook(r => ({ ...r, [f.key]: e.target.value }))}
                  style={{
                    width: '100%',
                    padding: '8px 10px',
                    border: `1px solid ${C.border}`,
                    borderRadius: '7px',
                    fontSize: '13px',
                    color: C.text,
                    background: 'white',
                    outline: 'none',
                    fontFamily: FONT_BODY,
                  }}
                >
                  {f.opts.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
                </select>
              </div>
            ))}
            {[
              ['standard_sla_h', 'SLA standard (heures)', 48, 1, 168],
              ['priorite_sla_h', 'SLA urgent (heures)',   24, 1, 48],
            ].map(([k, l, def, mn, mx]) => (
              <div key={k}>
                <div style={{
                  fontSize: '11px',
                  color: C.text3,
                  textTransform: 'uppercase',
                  letterSpacing: '0.06em',
                  fontWeight: 600,
                  marginBottom: '6px',
                }}>{l}</div>
                <input
                  type="number"
                  value={runbook[k] || def}
                  min={mn}
                  max={mx}
                  onChange={e => setRunbook(r => ({ ...r, [k]: parseInt(e.target.value) || 0 }))}
                  style={{
                    width: '100%',
                    padding: '8px 10px',
                    border: `1px solid ${C.border}`,
                    borderRadius: '7px',
                    fontSize: '13px',
                    color: C.text,
                    outline: 'none',
                    fontFamily: FONT_BODY,
                  }}
                />
              </div>
            ))}
          </div>

          <div style={{ marginBottom: '20px' }}>
            <div style={{
              fontSize: '11px',
              color: C.text3,
              textTransform: 'uppercase',
              letterSpacing: '0.06em',
              fontWeight: 600,
              marginBottom: '6px',
            }}>Instructions libres</div>
            <textarea
              value={runbook.instructions_libres || ''}
              onChange={e => setRunbook(r => ({ ...r, instructions_libres: e.target.value }))}
              placeholder="Ex: Toujours vérifier le SIREN avant traitement. Demander une pièce d'identité si client inconnu."
              style={{
                width: '100%',
                minHeight: '110px',
                padding: '10px',
                border: `1px solid ${C.border}`,
                borderRadius: '7px',
                fontSize: '13px',
                color: C.text,
                outline: 'none',
                resize: 'vertical',
                fontFamily: FONT_BODY,
              }}
            />
          </div>

          <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
            <button
              onClick={handleSaveRunbook}
              disabled={savingRunbook}
              style={{
                background: C.gold,
                color: '#fff',
                border: 'none',
                padding: '8px 18px',
                borderRadius: '7px',
                fontSize: '12.5px',
                fontWeight: 500,
                cursor: savingRunbook ? 'not-allowed' : 'pointer',
                opacity: savingRunbook ? 0.6 : 1,
                fontFamily: FONT_BODY,
              }}
            >
              {savingRunbook ? 'Sauvegarde…' : 'Sauvegarder'}
            </button>
            {runbookToast && (
              <span style={{
                fontSize: '12px',
                color: runbookToast.includes('Erreur') ? C.red : C.green,
              }}>
                {runbookToast}
              </span>
            )}
          </div>
        </div>
      )}

      {/* Capacités débloquées : uniquement onglet interne avec formalistes */}
      {tab === 'internal' && internal.length > 0 && (
        <div style={{
          background: C.card,
          border: `1px solid ${C.border}`,
          borderRadius: '12px',
          padding: '1.25rem',
          boxShadow: '0 1px 2px rgba(20,18,14,0.03)',
          marginTop: '20px',
        }}>
          <div style={{ fontSize: '11px', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.06em', color: C.text3, marginBottom: '14px' }}>
            Ce que votre équipe débloque grâce à Lexback
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '16px' }}>
            {[
              { title: '+40% productivité', sub: 'Robots INPI, Pappers, INSEE pré-remplissent les dossiers' },
              { title: 'IA Klear',          sub: 'Classement automatique des pièces et détection des formalités' },
              { title: 'Stack intégrée',    sub: 'Aircall, Zendesk, Airtable synchronisés automatiquement' },
              { title: 'SLA & reporting',   sub: 'Métriques temps réel par formaliste et par type' },
            ].map((c, i) => (
              <div key={i} style={{ display: 'flex', gap: '10px', alignItems: 'flex-start' }}>
                <div style={{
                  width: '30px', height: '30px',
                  background: C.goldBg,
                  borderRadius: '7px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexShrink: 0,
                  color: C.gold,
                  fontWeight: 600,
                  fontSize: '13px',
                }}>✓</div>
                <div>
                  <div style={{ fontSize: '12.5px', fontWeight: 500, color: C.text, marginBottom: '2px' }}>{c.title}</div>
                  <div style={{ fontSize: '11.5px', color: C.text3, lineHeight: 1.5 }}>{c.sub}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* CTA Lexback (uniquement onglet Lexback et liste vide) */}
      {tab === 'lexback' && lexback.length === 0 && isAdmin && (
        <div style={{
          background: `linear-gradient(135deg, ${C.goldBg}, rgba(199,140,42,0.04))`,
          border: `1px solid ${C.goldBg}`,
          borderRadius: '12px',
          padding: '1.5rem',
          marginTop: '20px',
        }}>
          <div style={{ fontFamily: FONT_TITLE, fontSize: '17px', fontWeight: 600, color: C.gold, marginBottom: '6px', letterSpacing: '-0.01em' }}>
            Pourquoi une équipe Lexback dédiée&nbsp;?
          </div>
          <div style={{ fontSize: '12.5px', color: C.text2, lineHeight: 1.6, marginBottom: '12px', maxWidth: '640px' }}>
            Vos formalistes internes sont précieux mais limités en capacité. Ajoutez des formalistes Lexback pour absorber les pics de volume, sans embaucher.
          </div>
          <a
            href="mailto:contact@swap-business.com?subject=Demande%20%C3%A9quipe%20Lexback%20d%C3%A9di%C3%A9e"
            style={{
              display: 'inline-block',
              background: C.text,
              color: '#fff',
              padding: '8px 16px',
              borderRadius: '7px',
              fontSize: '12.5px',
              fontWeight: 500,
              textDecoration: 'none',
            }}
          >Parler à un conseiller →</a>
        </div>
      )}

    </div>
  );
}
